export const getCaptchaKeyEndpoint = '/api/v1/config/siteKey'
export const getBrandEndpoint = '/api/v1/config/marca'
export const requestPasswordResetEndpoint = '/api/v1/recuperacionContrasena/:marcaComercial/solicitar'
export const changePasswordEndpoint = '/api/v1/recuperacionContrasena/:marcaComercial/confirmar'
